<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :hint="$t('Integrations_Field_Name_Description')"
        :label="$t('Integrations_Field_Name')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
          data-qa="integration-name"
        />
      </rest-form-item>
    </form-section>

    <form-section
      :title="$t('Integrations_WebhookStream_DeliveryDestination_Title')"
      :description="
        $t('Integrations_WebhookStream_DeliveryDestination_Description')
      "
    >
      <div class="webhook-stream-row">
        <rest-form-item
          class="webhook-stream-row__url"
          :label="$t('Integrations_WebhookStream_Destination_Url_Field')"
          prop="params.destination_url"
        >
          <el-input
            v-model="model.params.destination_url"
            :placeholder="
              $t('Integrations_WebhookStream_Destination_Url_Field')
            "
            data-qa="destination-url"
          />
        </rest-form-item>
        <rest-form-item
          class="webhook-stream-row__batch-size"
          :label="$t('Integrations_Field_WebhookStream_Batch_Size')"
          prop="params.batch_size"
        >
          <el-input-number
            v-model="model.params.batch_size"
            :step="1"
            controls-position="right"
            class="webhook-stream-row__batch-size-input"
            data-qa="batch-size"
          />
        </rest-form-item>
      </div>
      <rest-form-item
        :label="$t('Integrations_WebhookStream_AuthMethod_Field')"
        prop="params.use_oauth"
      >
        <el-select
          v-model="model.params.use_oauth"
          data-qa="destination-auth-method"
        >
          <el-option
            :value="true"
            :label="$t('Integrations_WebhookStream_AuthMethod_Oauth2')"
          />
          <el-option
            :value="false"
            :label="$t('Integrations_WebhookStream_AuthMethod_BearerToken')"
          />
        </el-select>
      </rest-form-item>
      <rest-form-item
        v-if="!model.params.use_oauth"
        :label="$t('Integrations_WebhookStream_AuthBearer_Token_Field')"
        prop="params.bearer_token"
      >
        <el-input
          v-model="model.params.bearer_token"
          :placeholder="$t('Integrations_WebhookStream_AuthBearer_Token_Field')"
          data-qa="bearer-token"
        />
      </rest-form-item>
      <div v-if="model.params.use_oauth">
        <rest-form-item
          :label="$t('Integrations_WebhookStream_Oauth_Auth_Url_Field')"
          prop="params.oauth_auth_url"
        >
          <el-input
            v-model="model.params.oauth_auth_url"
            :placeholder="$t('Integrations_WebhookStream_Oauth_Auth_Url_Field')"
            data-qa="auth-url"
          />
        </rest-form-item>
        <rest-form-item
          :label="$t('Integrations_WebhookStream_Oauth_Client_ID_Field')"
          prop="params.oauth_client_id"
        >
          <el-input
            v-model="model.params.oauth_client_id"
            :placeholder="
              $t('Integrations_WebhookStream_Oauth_Client_ID_Field')
            "
            data-qa="client-id"
          />
        </rest-form-item>
        <rest-form-item
          :label="$t('Integrations_WebhookStream_Oauth_Client_Secret_Field')"
          prop="params.oauth_client_secret"
        >
          <el-input
            v-model="model.params.oauth_client_secret"
            :placeholder="
              $t('Integrations_WebhookStream_Oauth_Client_Secret_Field')
            "
            data-qa="client-secret"
          />
        </rest-form-item>
        <rest-form-item
          :label="$t('Integrations_WebhookStream_Oauth_Scope_Field')"
          prop="params.oauth_scope"
        >
          <el-input
            v-model="model.params.oauth_scope"
            :placeholder="$t('Integrations_WebhookStream_Oauth_Scope_Field')"
            data-qa="oauth-scope"
          />
        </rest-form-item>
      </div>
    </form-section>

    <form-section
      v-if="showSegmentSourceSection"
      :title="$t('Integrations_WebhookStream_SegmentSource_Title')"
      :description="$t('Integrations_WebhookStream_SegmentSource_Description')"
    >
      <rest-form-item
        :label="$t('Integrations_WebhookStream_SegmentSource_Enabled_Field')"
        prop="params.external_segments_enabled"
      >
        <el-switch
          v-model="model.params.external_segments_enabled"
          data-qa="external-segments-enabled"
        />
      </rest-form-item>

      <template v-if="model.params.external_segments_enabled">
        <rest-form-item
          :label="$t('Integrations_WebhookStream_SegmentSource_Url_Field')"
          prop="params.external_segments_url"
        >
          <el-input
            v-model="model.params.external_segments_url"
            :placeholder="
              $t('Integrations_WebhookStream_SegmentSource_Url_Field')
            "
            data-qa="external-segments-url"
          />
        </rest-form-item>

        <rest-form-item
          :label="$t('Integrations_WebhookStream_AuthMethod_Field')"
          prop="params.external_segments_auth"
        >
          <el-select
            v-model="model.params.external_segments_auth"
            data-qa="external-segments-auth-method"
          >
            <el-option
              :value="null"
              :label="
                $t('Integrations_WebhookStream_AuthMethod_SameAsDestination')
              "
            />
            <el-option
              :value="true"
              :label="$t('Integrations_WebhookStream_AuthMethod_Oauth2')"
            />
            <el-option
              :value="false"
              :label="$t('Integrations_WebhookStream_AuthMethod_BearerToken')"
            />
          </el-select>
        </rest-form-item>

        <rest-form-item
          v-if="
            model.params.external_segments_auth !== null &&
              !model.params.external_segments_auth
          "
          :label="$t('Integrations_WebhookStream_AuthBearer_Token_Field')"
          prop="params.external_segments_bearer_token"
        >
          <el-input
            v-model="model.params.external_segments_bearer_token"
            :placeholder="
              $t('Integrations_WebhookStream_AuthBearer_Token_Field')
            "
            data-qa="external-segments-bearer-token"
          />
        </rest-form-item>

        <div
          v-if="
            model.params.external_segments_auth !== null &&
              model.params.external_segments_auth
          "
        >
          <rest-form-item
            :label="$t('Integrations_WebhookStream_Oauth_Auth_Url_Field')"
            prop="params.external_segments_oauth_auth_url"
          >
            <el-input
              v-model="model.params.external_segments_oauth_auth_url"
              :placeholder="
                $t('Integrations_WebhookStream_Oauth_Auth_Url_Field')
              "
              data-qa="external-segments-auth-url"
            />
          </rest-form-item>
          <rest-form-item
            :label="$t('Integrations_WebhookStream_Oauth_Client_ID_Field')"
            prop="params.external_segments_oauth_client_id"
          >
            <el-input
              v-model="model.params.external_segments_oauth_client_id"
              :placeholder="
                $t('Integrations_WebhookStream_Oauth_Client_ID_Field')
              "
              data-qa="external-segments-client-id"
            />
          </rest-form-item>
          <rest-form-item
            :label="$t('Integrations_WebhookStream_Oauth_Client_Secret_Field')"
            prop="params.external_segments_oauth_client_secret"
          >
            <el-input
              v-model="model.params.external_segments_oauth_client_secret"
              :placeholder="
                $t('Integrations_WebhookStream_Oauth_Client_Secret_Field')
              "
              data-qa="external-segments-client-secret"
            />
          </rest-form-item>
          <rest-form-item
            :label="$t('Integrations_WebhookStream_Oauth_Scope_Field')"
            prop="params.external_segments_oauth_scope"
          >
            <el-input
              v-model="model.params.external_segments_oauth_scope"
              :placeholder="$t('Integrations_WebhookStream_Oauth_Scope_Field')"
              data-qa="external-segments-oauth-scope"
            />
          </rest-form-item>
        </div>
      </template>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'

const BATCH_SIZE_MIN = 1
const BATCH_SIZE_MAX = 1000
const BATCH_SIZE_DEFAULT = 100

export default {
  name: 'WebhookStreamSettings',
  components: { RestFormItem, FormSection },
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  created() {
    if (this.isCreatePage) {
      this.model.params = {
        destination_url: '',
        use_oauth: false,
        batch_size: BATCH_SIZE_DEFAULT,
        external_segments_enabled: false,
        external_segments_auth: null
      }
    } else {
      this.model.params = {
        external_segments_auth: null,
        ...this.model.params
      }

      if (this.model.params.batch_size == null) {
        // Old integrations were saved before Batch Size existed, so they
        // have no value. Show the default so the field is never empty.
        this.$set(this.model.params, 'batch_size', BATCH_SIZE_DEFAULT)
      }
    }
  },
  data() {
    return {
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          destination_url: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            },
            {
              type: 'url',
              message: this.$t('RestForm_FieldUrlInvalid')
            }
          ],
          batch_size: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            },
            {
              type: 'integer',
              min: BATCH_SIZE_MIN,
              max: BATCH_SIZE_MAX,
              message: this.$t(
                'Integrations_Field_WebhookStream_Batch_Size_Invalid',
                { min: BATCH_SIZE_MIN, max: BATCH_SIZE_MAX }
              )
            }
          ],
          oauth_auth_url: [
            {
              required: true,
              message: this.$t('RestForm_FieldIsRequired')
            },
            {
              type: 'url',
              message: this.$t('RestForm_FieldUrlInvalid')
            }
          ],
          oauth_client_id: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          oauth_client_secret: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          external_segments_url: [
            {
              required: false,
              message: this.$t('RestForm_FieldIsRequired')
            },
            {
              validator: this.validateHttpsUrl
            }
          ],
          external_segments_oauth_auth_url: [
            {
              required: false,
              message: this.$t('RestForm_FieldIsRequired')
            },
            {
              validator: this.validateHttpsUrl
            }
          ],
          external_segments_oauth_client_id: {
            required: false,
            message: this.$t('RestForm_FieldIsRequired')
          },
          external_segments_oauth_client_secret: {
            required: false,
            message: this.$t('RestForm_FieldIsRequired')
          }
        }
      }
    }
  },
  computed: {
    isCreatePage() {
      return !this.$route.query.id
    },
    showSegmentSourceSection() {
      return (
        this.$hasReleaseFlag('external-segment-picker') &&
        this.$hasFeature('externalSegmentPicker')
      )
    }
  },
  methods: {
    validateHttpsUrl(rule, value, callback) {
      if (!value) {
        callback()
        return
      }
      try {
        if (new URL(value).protocol === 'https:') {
          callback()
          return
        }
      } catch (e) {
        // falls through to error below
      }
      callback(
        new Error(
          this.$t('Integrations_WebhookStream_SegmentSource_Url_HttpsOnly')
        )
      )
    }
  },
  watch: {
    model: {
      deep: true,
      handler() {
        const segmentSourceEnabled = !!this.model.params
          .external_segments_enabled
        this.rules.params.external_segments_url[0].required = segmentSourceEnabled

        const overrideAuth =
          segmentSourceEnabled &&
          !this.model.params.external_segments_use_integration_auth
        const overrideOauth =
          overrideAuth && !!this.model.params.external_segments_use_oauth

        this.rules.params.external_segments_oauth_auth_url[0].required = overrideOauth
        this.rules.params.external_segments_oauth_client_id.required = overrideOauth
        this.rules.params.external_segments_oauth_client_secret.required = overrideOauth
      }
    }
  }
}
</script>

<style scoped>
.webhook-stream-row {
  display: flex;
  gap: 16px;
}

.webhook-stream-row__url {
  width: 75%;
}

.webhook-stream-row__batch-size {
  width: 25%;
}

.webhook-stream-row__batch-size-input {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/webhookstream/WebhookStreamSettings.vue